export default __webpack_public_path__ + "static/media/06.2e026dd9.webp";